@if (!loading()) {
  <div>
    <canvas #graphCanvas></canvas>
  </div>
} @else {
  <div class="loading-area">
    <app-loading-spinner></app-loading-spinner>
  </div>
}
